import React__default from 'react';
import { SpecificDataviewType, ActionValue } from '@keepeek/commons';
import { Box, Link, Typography, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

var ElementLinks = function (_a) {
    var actionClick = _a.actionClick, associationClick = _a.associationClick, displayAttachmentsButton = _a.displayAttachmentsButton, displayMediaLinksButton = _a.displayMediaLinksButton, _b = _a.dataviewType, dataviewType = _b === void 0 ? SpecificDataviewType.MOSAIC : _b;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Box, { sx: {
            display: "flex",
            justifyContent: dataviewType === SpecificDataviewType.MOSAIC ? "space-between" : "flex-end",
            background: function (theme) {
                return dataviewType === SpecificDataviewType.MOSAIC ? theme.palette.grey[100] : "transparent";
            },
            padding: function (theme) { return theme.spacing(0.5, 2); },
            borderTop: function (theme) {
                return dataviewType === SpecificDataviewType.MOSAIC
                    ? "1px solid ".concat(theme.palette.grey[200])
                    : "none";
            }
        } },
        displayMediaLinksButton && (React__default.createElement(Link, { component: "button", color: "primary", underline: "hover", onClick: associationClick },
            React__default.createElement(Typography, { sx: { fontSize: "0.8rem", fontWeight: "bold" } }, t("components.element-summary.links.media-links")))),
        dataviewType === SpecificDataviewType.LIST &&
            displayMediaLinksButton &&
            displayAttachmentsButton && (React__default.createElement(Divider, { orientation: "vertical", flexItem: true, sx: {
                marginLeft: function (theme) { return theme.spacing(0.5); },
                marginRight: function (theme) { return theme.spacing(0.5); }
            } })),
        displayAttachmentsButton && (React__default.createElement(Link, { component: "button", color: "primary", underline: "hover", onClick: function (e) {
                actionClick(ActionValue.SHOW_ATTACHMENT, e);
            } },
            React__default.createElement(Typography, { sx: { fontSize: "0.8rem", fontWeight: "bold" } }, t("components.element-summary.links.attachments"))))));
};

export { ElementLinks as default };
//# sourceMappingURL=index.js.map
